import { makeStyles } from '@paintscout/ui'
import moment from 'moment'
import React from 'react'
import type { HeaderProps } from 'react-big-calendar'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '28px',
    color: theme.paintscout.palette.brand.Neutral.P50,
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 500,
    lineHeight: 1
  }
}))

export default function MonthColumnHeader(props: HeaderProps) {
  const classes = useStyles()
  return <div className={classes.root}>{moment(props.date).format('ddd')}</div>
}
